
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { sdgsData } from "@/data/sdgs";

interface StoryEditorSDGsProps {
  formState: any;
  onSdgToggle: (sdgId: number) => void;
}

const StoryEditorSDGs: React.FC<StoryEditorSDGsProps> = ({ 
  formState, 
  onSdgToggle 
}) => {
  const { language } = useLanguage();
  
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-sm text-muted-foreground">
        {language === "en" ? "Related SDGs" : "أهداف التنمية المستدامة ذات الصلة"}
      </h3>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {sdgsData.map((sdg) => (
          <div 
            key={sdg.id}
            className={`flex items-center p-2 border rounded-md cursor-pointer transition-all ${
              formState.sdgIds.includes(sdg.id) 
                ? 'border-palsustain-green bg-palsustain-green/5' 
                : 'border-muted hover:border-palsustain-green/30'
            }`}
            onClick={() => onSdgToggle(sdg.id)}
          >
            <div 
              className="w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0"
              style={{ backgroundColor: sdg.color }}
            >
              <span className="text-xs font-semibold text-white">{sdg.id}</span>
            </div>
            <span className="text-xs">
              {language === "en" ? sdg.shortTitle.en : sdg.shortTitle.ar}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StoryEditorSDGs;
